import { useTranslation } from "react-i18next";
import { MotionReveal } from "./MotionReveal";

const EMBEDS = [
  { id: "DC5DwMahgjg", title: "SIAT overview" },
  { id: "od1r0fgriQ4", title: "SIAT features" },
  { id: "9utqxeHobkU", title: "BikeAlert" },
  { id: "feM65He3v98", title: "BikeAlert how" },
];

export function Videos() {
  const { t } = useTranslation("global");

  return (
    <div id="videos" className="siat-media-col">
      <MotionReveal className="siat-intro">
        <p className="siat-eyebrow">{t("navigation.videos")}</p>
        <h2>{t("videos.title")}</h2>
        <p className="siat-lead">{t("videos.subtitle")}</p>
      </MotionReveal>
      <div className="siat-videos">
        {EMBEDS.map((video) => (
          <MotionReveal key={video.id}>
            <iframe
              title={video.title}
              src={`https://www.youtube.com/embed/${video.id}`}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </MotionReveal>
        ))}
      </div>
    </div>
  );
}
